import http from "@/http"

let modulePath = "company/Registration";

const post = function(path, data, config = {}) {
  return http.post(`${modulePath}/${path}`, data, config);
}

const get = function(path, config = {}) {
  return http.get(`${modulePath}/${path}`,config);
}

export default {
  getRegistrationEnquiry(jwt, enqParamsObj) {
    return get("enquiry", {
      headers: {
        Authorization: "Bearer " + jwt
      },
      params: enqParamsObj
    })
  },
  postSave(jwt, formType, items) {
    let dataObj = {
      type: formType,
      items: items
    }
    return post("save", dataObj, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwt
      }
    })
  },
  postEdit(jwt, item) {
    return post("edit", item, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwt
      }
    })
  },
  postRecordCancel(jwt, item) {
    return post("cancel", item, {
      headers: {
        Authorization: "Bearer " + jwt
      }
    })
  },
  postRecordResend(jwt, item) {
    return post("resend", item, {
      headers: {
        Authorization: "Bearer " + jwt
      }
    })
  }
}